import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from 'components/material-symbol/icons/Edit'
import { getInitials } from 'lib/text-display'
import useChromeStyles from 'pages/schedule/SelectLessonTime/redesign/styles'
import useStyles from './styles'

// Grey "who is taking the lesson" row at the top of the payment card, with a
// pencil that goes back to step 2.
const StudentRow = ({ name, subtitle, editUrl }) => {
  const classes = useStyles()
  const chrome = useChromeStyles()

  return (
    <div className={classes.whoRow}>
      <Avatar className={classes.whoAvatar} aria-hidden="true">
        {getInitials(name)}
      </Avatar>
      <div className={classes.whoText}>
        <p className={classes.whoName} data-testid="student-name">
          {name}
        </p>
        {subtitle && <p className={classes.whoSub}>{subtitle}</p>}
      </div>
      <IconButton
        component={Link}
        to={editUrl}
        aria-label="Change student"
        className={chrome.roundButton}
      >
        <EditIcon aria-hidden="true" />
      </IconButton>
    </div>
  )
}

StudentRow.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  editUrl: PropTypes.string.isRequired,
}

export default StudentRow
